import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ILinkManagerInjectable } from '@src/slide/application/service/link-manager/core/link-manager.interface';

export class LinkManagerInjectable implements ILinkManagerInjectable {
    public get supportLinkInfo(): boolean {
        return appConfigInstance.getConfig('custom.feature.supportLinkInfo' as any) ?? true;
    }
}
